export const endpoint = {
    accountantSignIn: "/accountant/signIn",
    accountantForgotPassword: "/accountant/forgotPassword",
    accountantResetPassword: "/accountant/resetPassword",
    accountantChangePassword: "/accountant/changePassword",
    getLogin: "/adminLogin",
    changePassword: "/changePassword",
    resetPassword: '/resetPassword',
    verifyOtp:'/verifyOtp',
    adminForgotPassword:"/adminForgotPassword",
    getAdminProfile:"/accountant/getProfile",
    listOfNotification: "/accountant/listOfNotification",
    readAllNotification: "/accountant/readAllNotification",
    addDriver: "/accountant/addDriver",
    verifyDriverFingerprintSignature: "/accountant/verifyDriverFingerprintSignature",
    sendOtp: "/accountant/sendOtp",
    otpVerify: "/accountant/otpVerify",
    listOfAlllocation: "/accountant/listOfAlllocation",
    listOfAlllocationForTripBreak: "/accountant/listOfAlllocationForTripBreak",
    listOfDriver: "/accountant/listOfDriver",
    listOfDriverSalary: "/accountant/listOfDriverSalary",
    listOfDriverLedger: "/accountant/listOfDriverLedger",
    getDriverLedgerCSV: "/accountant/getDriverLedgerCSV",
    getDriverLedgerCsvLog: "/accountant/getDriverLedgerCsvLog",
    listOfLedgerType: "/accountant/listOfLedgerType",
    getDriverSalaryDetails: "/accountant/getDriverSalaryDetails",
    salaryDisbursement: "/accountant/salaryDisbursement",
    paymentHistory: "/accountant/paymentHistory",
    getPaymentHistoryCSV: "/accountant/getPaymentHistoryCSV",
    getPaymentCsvLog: "/accountant/getPaymentCsvLog",
    updateStatusDriver: "/accountant/updateStatusDriver",
    editDriver: "/accountant/editDriver",
    viewDriver: "/accountant/viewDriver",
    listOfTripHistory: "/accountant/listOfTripHistory",
    listOfRoute: "/accountant/listOfRoute",
    viewRouteDetails: "/accountant/viewRouteDetails",
    listOfAllVehicle: "/accountant/listOfAllVehicle",
    listOfAllDriver: "/accountant/listOfAllDriver",
    addTrip: "/accountant/addTrip",
    listOfTrip: "/accountant/listOfTrip",
    updateChallanNumber: "/accountant/updateChallanNumber",
    viewTripDetails: "/accountant/viewTripDetails",
    tripBreak: "/accountant/tripBreak",
    listOfTripBreak: "/accountant/listOfTripBreak",
    endTrip: "/accountant/endTrip",
    addTripExpence: "/accountant/addTripExpence",
    listOfExpence: "/accountant/listOfExpence",
    listOfExpenceForChangeRequest: "/accountant/listOfExpenceForChangeRequest",
    requestTypeList: "/accountant/requestTypeList",
    gateDriversForWaiveOff: "/accountant/getDriversForWaiveOff",
    createDebitNoteRequest: "/accountant/createDebitNoteRequest",
    createWaiveOffRequest: "/accountant/createWaiveOffRequest",
    createTripExpenseChangeRequest: "/accountant/createTripExpenseChangeRequest",
    listOfChangeRequest: "/accountant/listOfChangeRequest",
    viewChangeRequest: "/accountant/viewChangeRequest",
    getAllusers:'/getAllusers',
    getUserDetails:"/getUserDetails",
    deleteUser: "/deleteUser",
    updateStatus:'/updateStatus',
    getEventsCreatedByUser:'/getEventsCreatedByUser',
    getCms:"/getCms",
    updateCms:'/updateCms',
    deleteUser:'/deleteUser',
    getEvent:'/getEvent',
    getEventByPartyId:'/getEventParticipantsByEventId',
    getAllEvents:'/getAllEvents',
    getEventById:'/getEventById',
    getSubAdminList:'/getSubAdminList',
    logout:'/logout',
    moduleList:'/getModuleList',
    createRole:'/createRole',
    getRoleList:'/getRoleModuleWiseList',
    deleterole:'/deleteRole',
    subAdminRole:'/getRoleList',
    createSubAdmin:'/createSubAdminRole',
    getDashboarddata:'/getDashboardData',
    SubAdminView:'/viewSubAdmin',
    updateSubAdmin:'/updateSubAdmin',
    deleteSubAdmin:'/deleteSubAdmin',
    blockSubAdmin:'/blockUnblockSubAdmin',
    getRoleByid:'/getRoleModuleById',
    editRole:'/editRole'
}